import { Pool } from "../../../utils/Pool";
import { FastSinglelist } from "../../../utils/SingletonList";
import { MeshInstanceGeometry } from "../../graphics/MeshInstanceGeometry";
import { RenderElement } from "./RenderElement";
export class InstanceRenderElement extends RenderElement {
    static create() {
        let elemet = InstanceRenderElement._pool.take();
        elemet._isInPool = false;
        elemet.clear();
        return elemet;
    }
    constructor() {
        super();
        this._InvertFront = false;
        this.setGeometry(new MeshInstanceGeometry(null));
        this._instanceBatchElementList = new FastSinglelist();
        this._isUpdataData = true;
        this._invertFrontFace = false;
    }
    getInvertFront() {
        return this._invertFrontFace;
    }
    set InvertFront(value) {
        this._InvertFront = value;
    }
    _createRenderElementOBJ() {
    }
    compileShader(context) {
        var passes = this._subShader._passes;
    }
    _renderUpdatePre(context) {
    }
    updateInstanceData(mesh) {
    }
    clear() {
        this._instanceBatchElementList.length = 0;
    }
    recover() {
    }
}
InstanceRenderElement.maxInstanceCount = 1024;
InstanceRenderElement._pool = Pool.createPool(InstanceRenderElement);
